<template lang="pug">
  div
    v-card(class="mb-12" height="auto")
      ModalTindakan( :openModal="openModalTindakan" @onClose=" openModalTindakan = false" @handleSaveData="handleSaveData")
      EditTindakan( @handleEditData="handleEditData" ref="modal")
      v-layout(row wrap)
        v-flex(xs12 sm12) 
            img(src="../../assets/table_matriks.png" style="width:70%;margin-left:18px")

        v-flex(xs12 sm12 style="margin-top:20px") 
            h3(class="headerSection") Tingkat Risiko Awal
            br
        v-flex
            div(style="margin: 0 0 0 30px;padding: 0;}")
                v-layout(row wrap)
                    v-flex(xs10 sm3 style="margin-right:40px")
                        span Nilai Konsekuensi
                        v-autocomplete(
                          class="inputDefault"
                          v-model="konsekAwal"
                          style="margin-top:10px"
                          :items="dataNilai"
                          item-text="label"
                          item-value="value"
                          solo
                          label="Pilih")
                    v-flex(xs10 sm3 style="margin-right:40px")   
                        span Kekerapan / Kemungkinan
                        v-autocomplete(
                          class="inputDefault"
                          v-model="kekerapanAwal"
                          style="margin-top:10px"
                          :items="dataNilaiKekerapan"
                          item-value="value"
                          item-text="label"
                          solo
                          label="Pilih")
                    v-flex(xs10 sm3 style="margin-right:40px")
                        span Tingkat Risiko
                        v-text-field(style="margin-top:10px" type="number" v-model="tngktResikoAwal" class="inputDefault" solo-inverted disabled)
        
        v-flex(xs12 sm12 style="margin-top:20px") 
            h3(class="headerSection") Tingkat Risiko Setelah Perubahan
            br
        v-flex
            div(style="margin: 0 0 0 30px;padding: 0;}")
                v-layout(row wrap)
                    v-flex(xs10 sm3 style="margin-right:40px")
                        span Nilai Konsekuensi
                        v-autocomplete(
                          class="inputDefault"
                          v-model="konsekPerubahan"
                          style="margin-top:10px"
                          :items="dataNilai"
                          item-value="value"
                          item-text="label"
                          solo
                          label="Pilih")
                    v-flex(xs10 sm3 style="margin-right:40px")
                        span Kekerapan / Kemungkinan
                        v-autocomplete(
                          class="inputDefault"
                          v-model="kekerapanPerubahan"
                          style="margin-top:10px"
                          :items="dataNilaiKekerapan"
                          item-value="value"
                          item-text="label"
                          solo
                          label="Pilih")
                    v-flex(xs10 sm3 style="margin-right:40px")
                        span Tingkat Risiko
                        v-text-field(style="margin-top:10px" type="number" v-model="tngktResikoPerubahan" class="inputDefault" solo-inverted disabled)

        v-flex(xs12 sm11 style="margin-top:10px;margin-left:18px") 
            v-alert(v-if="katResiko && colorInfo" border="top" outlined shaped type="info" :color="colorInfo") 
             span Tingkat Risiko 
             span(style="font-weight:bold") {{katResiko}}, 
             span(v-if="katResiko == 'Rendah'") Tidak Perlu Pengendalian Risiko. Terimakasih!
             span(v-else) Silahkan buat Tindakan untuk pengendalian. Terimakasih!
        
        v-flex(v-if="katResiko && katResiko != 'Rendah'" xs12 sm9 style="margin-top:20px") 
            h3(class="headerSection" style="margin-top:5px") Tindakan yang diperlukan untuk pengendalian
            br
        v-flex(v-if="katResiko && katResiko != 'Rendah'" xs12 sm3 style="margin-top:20px")
            v-btn(outlined color="#1976D2" style="margin-left:22px" @click="openModalTindkan()") Tambah Tindakan
        
        v-flex(v-if="katResiko && katResiko != 'Rendah'" xs12 sm12 style="margin-top:20px;margin-bottom:50px")
            v-data-table(
              :headers="headers"
              :items="dataSubmitPerubahan.ipTindakanPengendalian"
              :must-sort="true"
              :single-expand="true",
              hide-default-footer
              class="elevation-1")
              template(v-slot:item.statusTindakan="{ item }")
                v-chip(
                  label,
                  small,
                  :color="statusColor[item.statusTindakan].color",
                  style="width: 100%; justify-content: space-evenly",
                  text-color="black"
                ) {{ item.statusTindakan }}

              template(v-slot:item.actions="{ item, index}")
                v-icon( small
                  style="color: orange"
                  @click="handleEdit(item)")  mdi-pencil 
                v-icon(small
                  style="color: #FF4D4F;margin-left:10px"
                  @click="deleteItem(item)") mdi-delete                     

              template(slot="no-data") 
                img(src="../../assets/plus-circle.png" style="width:7%;margin-top:20px")
                p Belum ada tindakan, Silahkan tambah
                p(style="margin-top:-17px;margin-bottom:20px") tindakan terlebih dahulu
            br

    v-btn(class="mr-3" dark color='blue-grey' @click="backStep(3);scrollTop();") BACK
    v-btn(text class="mr-3" @click="backHome()") Cancel
    v-btn(color="primary" @click="nextStep(5); scrollTop();" :disabled="!isPageComplete") Continue
      
</template>

<script>
import { mapState } from "vuex";
import * as config from "../../config/index.json";
import ModalTindakan from "./ModalTindakan.vue";
import EditTindakan from "./EditTindakan.vue";
export default {
  name: "PenilaianResiko",
  components: {
    ModalTindakan,
    EditTindakan
  },
  props: ["e1","dataSubmitPerubahan"],
  data() {
    return {
      statusColor :{
        "OPEN" :{
          color : "#E4E83D"
        },
        "CONTINUE" :{
          color : "#4CAF50"
        },
        "CLOSE" :{
          color : "red"
        }
      },
      dataNilai: config.dataNilai,
      openModalTindakan:false,
      openEditTindakan:false,
      konsekAwal:"",
      kekerapanAwal:"",
      tngktResikoAwal:"",
      konsekPerubahan:"",
      kekerapanPerubahan:"",
      tngktResikoPerubahan:"",
      katResiko:"",
      colorInfo:"",
      headers: [
        {
          text: 'Nama Tindakan',
          align: 'start',
          sortable: false,
          value: 'titleTindakan',
        },
        { text: 'Tanggal', sortable: false, value: 'deadline' },
        { text: 'Oleh', sortable: false, value: 'penanggungJawab.name' },
        { text: 'Status',width:"120px", sortable: false, value: 'statusTindakan' },
        { text: 'Action', sortable: false, value: 'actions' }
      ],
      dataNilaiKekerapan: config.dataNilaiKekerapan
    };
  },
  mounted() {},
  computed: {
    ...mapState(["API_URL", "locations", "dataUsers","dataEditRequest"]),
    isPageComplete: function () {
      const rules = [
        this.konsekAwal &&
        this.tngktResikoAwal &&
        this.kekerapanAwal &&
        this.konsekPerubahan &&
        this.kekerapanPerubahan &&
        this.tngktResikoPerubahan
      ]

      if ( this.tngktResikoAwal && this.tngktResikoPerubahan > 4 ) {

        let statusTindakan = this.dataSubmitPerubahan.ipTindakanPengendalian.every((item) => {
          if (item.statusTindakan == 'CLOSE' && !item.lampiranUploadId) {
            return false;
          }
          return true;
        });

        rules[0] = this.dataSubmitPerubahan.ipTindakanPengendalian.length && statusTindakan
      }

      return (
        rules[0]
      );
    },
  },
  methods: {
    handleSaveData(val){
      this.dataSubmitPerubahan.ipTindakanPengendalian.push(val)
    },
    handleEditData(val){
      let objIndex =  this.dataSubmitPerubahan.ipTindakanPengendalian.findIndex((obj => obj == val));
      this.dataSubmitPerubahan.ipTindakanPengendalian[objIndex] = val
      let tempArray =  this.dataSubmitPerubahan.ipTindakanPengendalian
      this.dataSubmitPerubahan.ipTindakanPengendalian = []
      this.dataSubmitPerubahan.ipTindakanPengendalian = tempArray
    },
    deleteItem(val){
      this.dataSubmitPerubahan.ipTindakanPengendalian.splice(this.dataSubmitPerubahan.ipTindakanPengendalian.findIndex(item => item === val), 1)
    },
    handleEdit(val){
      this.$refs.modal.showModal(val);
    },
    openModalTindkan(){
      this.openModalTindakan = true
    },
    nextStep(val){
      this.dataSubmitPerubahan.ipTingkatRisikoAwal ={
        nilaiKonsekuensi : this.konsekAwal,
        kekerapan : this.kekerapanAwal,
        tingkatRisiko : this.tngktResikoAwal
      }
      this.dataSubmitPerubahan.ipTingkatRisikoSetelahPerubahan ={
        nilaiKonsekuensi : this.konsekPerubahan,
        kekerapan : this.kekerapanPerubahan,
        tingkatRisiko : this.tngktResikoPerubahan
      }  
     this.$emit("continueBtn", val);
    },
    backStep(val){
     this.$emit("continueBtn", val);
    },
    backHome(){
      this.$router.push("/my-permit");
    },
    scrollTop(){
      window.scrollTo(0,0);
    },
  },
  watch: {
    kekerapanAwal(val){
      this.tngktResikoAwal = this.konsekAwal * val 
    },
    konsekAwal(val){
      this.tngktResikoAwal = val * this.kekerapanAwal 
    },
    kekerapanPerubahan(val){
      this.tngktResikoPerubahan = this.konsekPerubahan * val 
    },
    konsekPerubahan(val){
      this.tngktResikoPerubahan = val * this.kekerapanPerubahan 
    },
    tngktResikoPerubahan(val){
      if(val >= 1 && val <= 4){
          this.katResiko = "Rendah"
          this.colorInfo = "#4CAF50"
      }else if (val >= 5 && val <= 9){
          this.katResiko = "Sedang"
          this.colorInfo = "#FFC000"
      }else if (val >= 10 && val <= 16){
          this.katResiko = "Tinggi"
          this.colorInfo = "#FFEA00"
      }else if (val >= 17 && val <= 25){
          this.katResiko = "Kritis"
          this.colorInfo = "#FF5252"
      }else{
        this.katResiko = ""
        this.colorInfo = ""
      }
    },
    dataEditRequest() {
      this.konsekAwal = this.dataEditRequest.ipTingkatRisikoAwal.nilaiKonsekuensi
      this.kekerapanAwal = this.dataEditRequest.ipTingkatRisikoAwal.kekerapan
      this.tngktResikoAwal = this.dataEditRequest.ipTingkatRisikoAwal.tingkatRisiko
      this.konsekPerubahan = this.dataEditRequest.ipTingkatRisikoSetelahPerubahan.nilaiKonsekuensi
      this.kekerapanPerubahan = this.dataEditRequest.ipTingkatRisikoSetelahPerubahan.kekerapan
      this.tngktResikoPerubahan = this.dataEditRequest.ipTingkatRisikoSetelahPerubahan.tingkatRisiko
    }
  },
};
</script>

<style></style>
